import TableBody from "@mui/material/TableBody";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import {
  RowsSelected,
  SelectRow,
  UnselectRow,
} from "components/Table/useTableSelectable";
import { OLTheme } from "contexts/Theme/ThemeProvider";
import { Column, OLTableActions, Row } from "./OLTable";
import { OLTableRow } from "./OLTableRow";

const bodyStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    disabled: { "& td": { color: theme.gray400 } },
  }),
);
type OLTableBodyProps = {
  onRowClick?: (id: string) => void;
  actions?: Array<OLTableActions>;
  items: Array<Row>;
  selectable?: {
    rowsSelected: RowsSelected;
    selectRow: SelectRow;
    unselectRow: UnselectRow;
    disabled: boolean;
  };
  columns?: Column[];
  "data-test-id"?: string;
  disableActions?: boolean;
  columnRefs: React.MutableRefObject<(HTMLTableCellElement | null)[]>;
  calculateColumnLeftOffset: (index: number) => number;
};
export function OLTableBody({
  actions,
  items,
  selectable,
  onRowClick,
  columns,
  "data-test-id": dataTestId,
  disableActions,
  columnRefs,
  calculateColumnLeftOffset,
}: OLTableBodyProps) {
  const classes = bodyStyles();

  return (
    <TableBody>
      {items.map((item, index) => {
        const isRowSelected =
          selectable &&
          selectable.rowsSelected.findIndex((row) => row.id === item.id) !== -1;

        return (
          <OLTableRow
            onRowClick={onRowClick}
            actions={actions}
            className={`${item.metadata?.disabled && classes.disabled}`}
            id={item.id}
            items={item}
            key={item.id}
            selectable={
              selectable && {
                disabled: selectable.disabled,
                selected: !!isRowSelected,
                selectRow: selectable.selectRow,
                unselectRow: selectable.unselectRow,
              }
            }
            columns={columns}
            data-test-id={dataTestId && `${dataTestId}-table-row-${index}`}
            disableActions={disableActions}
            columnRefs={columnRefs}
            calculateColumnLeftOffset={calculateColumnLeftOffset}
          />
        );
      })}
    </TableBody>
  );
}
